export enum SalesTypes {
  Default = 0,
  Vietnam = 1,
  China = 2,
  Malaysia = 3,
  Wholesale = 4,
  Record = 5,
  SpecialVn = 6,
  SpecialCn = 7,
  SpecialMy = 8,
  Special = 9,
  KimTeam = 10,
  AU = 11,
}

export const salesTypeOptions = [
  {
    label: "Default",
    tab: "Default",
    value: SalesTypes.Default,
    rebate: 999,
    alphaRebate: 999,
    proRebate: 999,
  },
  {
    label: "Vietnam (2.5/1.25/1.5)",
    tab: "Vietnam",
    value: SalesTypes.Vietnam,
    rebate: 250,
    alphaRebate: 125,
    proRebate: 150,
  },
  {
    label: "China (2.5/1.5/1.5)",
    tab: "China",
    value: SalesTypes.China,
    rebate: 250,
    alphaRebate: 150,
    proRebate: 150,
  },
  {
    label: "Malaysia (2.5/1.5/1.5)",
    tab: "Malaysia",
    value: SalesTypes.Malaysia,
    rebate: 250,
    alphaRebate: 150,
    proRebate: 150,
  },
  {
    label: "Wholesale (4/2/1.5)",
    tab: "Wholesale",
    value: SalesTypes.Wholesale,
    rebate: 400,
    alphaRebate: 200,
    proRebate: 150,
  },
  {
    label: "Record",
    tab: "Record",
    value: SalesTypes.Record,
    rebate: 999,
    alphaRebate: 999,
    proRebate: 999,
  },
  {
    label: "Sepcial Vietnam",
    tab: "Sepcial Vietnam",
    value: SalesTypes.SpecialVn,
    rebate: 999,
    alphaRebate: 999,
    proRebate: 999,
  },
  {
    label: "Sepcial China",
    tab: "Sepcial China",
    value: SalesTypes.SpecialCn,
    rebate: 999,
    alphaRebate: 999,
    proRebate: 999,
  },
  {
    label: "Sepcial Malaysia (2.5/2.25/1.5)",
    tab: "Sepcial Malaysia",
    value: SalesTypes.SpecialMy,
    rebate: 250,
    alphaRebate: 225,
    proRebate: 150,
  },
  {
    label: "Sepcial Setting",
    tab: "Sepcial",
    value: SalesTypes.Special,
    rebate: 999,
    alphaRebate: 999,
    proRebate: 999,
  },
  {
    label: "AU ( 2.8/1.4/1.65)",
    tab: "AU",
    value: SalesTypes.AU,
    rebate: 280,
    alphaRebate: 140,
    proRebate: 165,
  },
];
